/**
 * Theme Initializer Module
 * Initializes all theme variants synchronously before React renders
 * This module is imported first in index.tsx to ensure themes are ready
 */

import { detectHmo } from "utils/hmoDetection";
import { createThemeWithHmo } from "assets/theme";
import { createThemeRtlWithHmo } from "assets/theme/theme-rtl";
import { hmoAwareColors } from "assets/theme/getHmoAwareColors";

// Detect HMO once at module load time (synchronous)
export const detectedHmo = detectHmo();

// Create all theme variants once - cached as module constants
export const theme = createThemeWithHmo(detectedHmo, 'ltr');
export const themeRTL = createThemeRtlWithHmo(detectedHmo);

// Set CSS variables and meta tags immediately
if (typeof document !== 'undefined') {
  
  // Update scrollbar colors via CSS variables (using HMO-aware colors)
  // These are used in index.html for custom scrollbar styling
  const scrollbarThumb = hmoAwareColors.scrollbar?.thumb || theme.palette.grey[300];
  const scrollbarShadow = hmoAwareColors.scrollbar?.shadow || 'rgba(0, 0, 0, 0.3)';
  document.documentElement.style.setProperty('--scrollbar-thumb', scrollbarThumb);
  document.documentElement.style.setProperty('--scrollbar-shadow', scrollbarShadow);
}

// Development assertion
if (process.env.NODE_ENV === 'development') {
  console.assert(!!theme && !!themeRTL, 'Themes must be initialized');
  console.log('[ThemeInitializer] HMO:', detectedHmo, '| Themes ready');
}

